import { render } from "./PsychosocialManagement.vue?vue&type=template&id=4dfe69aa&scoped=true"
import script from "./PsychosocialManagement.vue?vue&type=script&lang=js"
export * from "./PsychosocialManagement.vue?vue&type=script&lang=js"

import "./PsychosocialManagement.vue?vue&type=style&index=0&id=4dfe69aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfe69aa"]])

export default __exports__